module.exports = __webpack_public_path__ + "img/RDA_tipoH_flexi-2pax_35m2.5add94eb.png";